// 用来写插件
import axios from 'axios'
import router from "../router/index";

const MyHttpServer = {}
MyHttpServer.install = (Vue) => {

  // 本地测试服务器  系统-高级-TCP
  // 路由器
  // const server_ip = "http://192.168.50.243:80"
  // const server_ip = "http://192.168.1.2:80"
  // const server_ip = "http://192.168.1.11:80"
  // const server_ip = "http://192.168.10.5:80"

  // const server_ip = "http://127.0.0.1:5000/"
  // 灯塔 本地
  // const server_ip = "http://192.168.1.102:80"

  // 本地测试服务器：手机
  // const server_ip = "http://172.20.10.2"

  // 主服务器：
  // const server_ip = "https://szsxsurf.com"
  const server_ip = "http://117.50.64.252:3344"

  // 阿里云 正式服务器
  // const server_ip = "http://121.196.53.21:9080"

  // 腾讯云 正式服务器
  // const server_ip = "https://szsxsurf.com"

  // 腾讯云 ip
  // const server_ip = "http://81.68.230.233:8080"


  // 定义全局IP:上传器
  // const upload_id = "http://121.196.53.21:9080"
  const upload_id = server_ip
  // const upload_id = "http://127.0.0.1:5000/"
  Vue.prototype.$ip = upload_id

  // 配置默认url：
  // 本地
  axios.defaults.baseURL = server_ip
  // 阿里云 1.0
  // axios.defaults.baseURL = "http://121.196.53.21:8081/"
  // 阿里云 2.0
  // axios.defaults.baseURL = "http://121.196.53.21:9080/"

  // 跨域信任：axios.defaults.withCredentials = true
  axios.defaults.withCredentials = true

  // 添加请求头：此方法在发送登陆请求时 带了token
  // if (localStorage.getItem('userInfo')) {
  //     console.log("已登陆");
  //     const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  //     axios.defaults.headers = { "Authorization": userInfo.token }
  //     // axios.defaults.headers.common['Authorization'] = userInfo.token
  // }

  // 拦截器：
  // 拦截请求。用途1: 修改 config中的信息，请求报文，//如添加token，修改header /用途2: 加载动画
  axios.interceptors.request.use(config => {
    // console.log(config);
    // console.log("请求的是什么" + config.url); //当前请求的链接


    if (config.url !== "/login" && config.url !== "register" && config.url !== "/traver_terms" && config.url !== "/get_modify_terms") {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      console.log("token")
      config.headers.Authorization = userInfo.token
      // config.headers['z-token'] = userInfo.token
    }
    // else {
    //     this.$router.push({ path: "/login" });
    // }
    // 

    return config  // 将对象返回出去
  }, err => {
    return Promise.reject(err);
  });

  // 拦截响应：
  axios.interceptors.response.use(
    response => {
      const { errmsg, errno } = response.data
      // console.log(response);
      // console.log(errmsg);
      if (errno == "4601" || errno == "4602") {

        // 判断当前设备
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );

        // console.log(flag);
        if (flag === null) {
          // console.log("pc端");
          router.push({ name: 'login' })
        } else {
          router.push({ name: 'm_login' })
        }

        return response;
      }
      return response;
    },
    error => {
      return Promise.reject(error);
    }
  );

  Vue.prototype.$http = axios

  // 4. 添加实例方法,跨域白名单
  // const tpx_app = axios.create({
  //     baseURL: "127.0.0.1:5000/ ",
  // })

  // 逻辑...
  //  chrome://flags/#same-site-by-default-cookies
  //  chrome://flags/#cookies-without-same-site-must-be-secure
  //  这两项设置为Disabled，并重启浏览器,解决跨域时SameSite 的问题




  // 访问首页没问题，其他页面404.其实只要项目配置伪静态即可；
  // 宝塔-》网站-》设置-》伪静态
  // location / {
  //   if (!-e $request_filename) {
  //     rewrite  ^(.*)$ /index.html?s=/$1  last;
  //     break;
  //   }
  // }

}

export default MyHttpServer

